<template>
    <v-list two-line dense>
        <v-list-item v-for="c in contacts" :key="c.uuid">
            <v-list-item-content>
                <v-list-item-title>
                    {{c.name}}
                </v-list-item-title>
                <v-list-item-subtitle>
                    {{c.cell}}
                </v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>
    </v-list>
</template>

<script>
  export default {
    props:['contacts'],
    components: {},
    name: "ContactList",
    data() {
      return {}
    },
    mounted() {
    },
    methods: {}
  }
</script>

<style scoped>

</style>